import { useContext, useEffect, useState } from 'react';
import GlobalContext from '../../../contexts/globalContext';
import UseTraceItemShipping from '../../../hooks/useTraceItemShipping';
import UseVerificationDigit from '../../../hooks/useVerificationDigit';
import { getCertificateServices } from '../../../services/certificate-services';
import useBrowserMode from '../../../shared/hooks/useBrowserMode';
import { normalizeWords } from '../../../utils/normalizeWords';
import listTypeDoc from '../../../utils/typeDoc.json';
import Select from '@/components/atoms/select/select';
import { useForm } from 'react-hook-form';
import Input from '../../atoms/input/input';
import ErrorModal from '../../molecules/error-modal/errorModal';
import PdfViewModal from '../../molecules/pdf-view-modal/pdfViewModal';
import LoginRequest from '../login-request/login-request';
import BusinessModal from '../../molecules/bussiness-modal/businessModal';
import { generateOptionsDoc } from '@/utils/generateOptionsDoc';
import FormAndNoteTemplate from '../form-and-note-template/formAndNoteTemplate';
import './collaborator-affiliation-certificate.scss';
import { graphql, navigate, useStaticQuery } from 'gatsby';

const CollaboratorAffiliationCertificate = (props) => {
    const modalData = useStaticQuery(graphql`
        query MODAL_NO_AFFILIATE_WORKER {
            allContentfulTemplate(
                filter: { titulo: { eq: "Modal > Sin trabajadores afiliados" } }
            ) {
                nodes {
                    titulo
                    nombre
                    subtitulo
                    boton {
                        copy
                        redireccion
                    }
                }
            }
        }
    `);

    const { contentInfo } = props;
    const {
        register,
        setValue,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const [optionsTypeDoc, setOptionsTypeDoc] = useState([]);
    const [openToast, setOpenToast] = useState<any>(false);
    const [openModalError, setOpenModalError] = useState<any>(false);
    const [loader, setLoader] = useState(false);
    const [needSession, setNeedSession] = useState(false);
    const [visualizationModal, setVisualizationModal] = useState<any>(false);
    const [openBusinessModal, setOpenBusinessModal] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [bussinesModal, setBussinesModal] = useState(false);

    const { business, checkPermissionPage, userInfoContext, gigyaContext } =
        useContext(GlobalContext);
    const { localStorage, window } = useBrowserMode();

    useEffect(() => {
        checkPermissionPage?.set(contentInfo?.serviceId ?? null);
    }, [contentInfo?.serviceId]);

    const { nombre, subtitulo, boton } =
        modalData.allContentfulTemplate.nodes[0];

    const onSubmit = (data) => {
        setLoader(true);
        if (gigyaContext.gigyaAccount && business?.get) {
            if (
                data.document !== '' &&
                data.documentType !== '' &&
                business?.get
            ) {
                const typeDocumentCompany = listTypeDoc.filter(
                    (item) => item.typaDocSAP === business?.get?.companyDocType
                )[0].id;
                const numDocumentCompany =
                    business?.get?.companyDocID +
                    (business?.get?.companyDocType === 'CO1N'
                        ? UseVerificationDigit(
                              String(business?.get?.companyDocID)
                          )
                        : '');

                getCertificateServices(
                    data.document,
                    data.documentType,
                    userInfoContext.data?.userJwt,
                    numDocumentCompany,
                    typeDocumentCompany
                )
                    .then((result) => {
                        setLoader(false);
                        if (gigyaContext?.gigyaAccount) {
                            UseTraceItemShipping(
                                gigyaContext?.gigyaAccount?.profile.firstName +
                                    ' ' +
                                    (gigyaContext.gigyaAccount.data.secondName
                                        ? gigyaContext.gigyaAccount.data
                                              .secondName + ' '
                                        : '') +
                                    gigyaContext.gigyaAccount.profile.lastName +
                                    (gigyaContext.gigyaAccount.data
                                        .secondLastName
                                        ? ' ' +
                                          gigyaContext.gigyaAccount.data
                                              .secondLastName
                                        : ''),
                                gigyaContext?.gigyaAccount?.data.docNumber,
                                gigyaContext?.gigyaAccount?.data.docType,
                                gigyaContext?.gigyaAccount?.profile.email,
                                'click',
                                `CertificadosYConsultas :: ${normalizeWords(
                                    contentInfo.nombre
                                )} :: } ${
                                    contentInfo.referencias
                                        ? contentInfo.referencias[2].copyBoton
                                        : 'GenerarCertificado'
                                }`,
                                userInfoContext.data?.userJwt
                            );
                        }
                        if (result.data.status === 200) {
                            if (result.data.data.certificadoB64) {
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({
                                    event: 'pushEventGA',
                                    category:
                                        localStorage.getItem('CURRENT_TAB') ===
                                        'personas'
                                            ? 'HomePersonas'
                                            : 'HomeEmpresas',
                                    action: 'ClicCertificado',
                                    label: 'Certificado de afiliacion',
                                });
                                setVisualizationModal(
                                    <PdfViewModal
                                        base64={result.data.data.certificadoB64}
                                        setActiveModal={setVisualizationModal}
                                        selectedFileName="Certificado de afiliación colaborador"
                                        setActiveToast={setOpenToast}
                                    />
                                );
                            }
                        } else if (
                            result.data.status === 204 ||
                            result.data.status === 400
                        ) {
                            setOpenModalError(
                                <ErrorModal
                                    title={nombre}
                                    subtitle={result.data.userMessage}
                                    closeModal={() => setOpenModalError(false)}
                                    isMobile={true}
                                    buttonCopy={boton[0].copy}
                                    buttonEvent={() =>
                                        navigate(`${boton[0].redireccion}`)
                                    }
                                />
                            );
                        } else {
                            setOpenModalError(
                                <ErrorModal
                                    closeModal={() => setOpenModalError(false)}
                                    isMobile={true}
                                    buttonCopy="ACEPTAR"
                                />
                            );
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        setLoader(false);
                        setOpenModalError(
                            <ErrorModal
                                closeModal={() => setOpenModalError(false)}
                                isMobile={true}
                            />
                        );
                    });
            }
        } else {
            if (!gigyaContext.gigyaAccount) {
                setNeedSession(true);
            }
            if (!business?.get) {
                setOpenBusinessModal(true);
            }
        }
    };
    useEffect(() => {
        if (!business?.get) {
            setBussinesModal(true);
        }
    }, [business]);

    useEffect(() => {
        generateOptionsDoc(contentInfo.referencias[0].lista, setOptionsTypeDoc);
    }, []);

    return (
        <>
            {needSession ? (
                <LoginRequest />
            ) : (
                <>
                    {bussinesModal && (
                        <BusinessModal
                            closeModal={() => setBussinesModal(false)}
                            isMobile={true}
                            setShowConfirmation={setShowConfirmation}
                            isPrivate={false}
                            closeModalPermissionPage={() =>
                                setBussinesModal(false)
                            }
                            serviceId={contentInfo.serviceId}
                        />
                    )}
                    <FormAndNoteTemplate
                        buttonCopy={contentInfo.referencias[2].copyBoton}
                        disableButton={!business?.get}
                        buttonEvent={() => {
                            handleSubmit(onSubmit)();
                        }}
                        breadCrum={contentInfo.migaDePan}
                        title={contentInfo.nombre}
                        subtitle={contentInfo.subtitulo}
                        notePosition="left"
                        note={{
                            image: contentInfo.imagen[0],
                            content: contentInfo.descripcion,
                        }}
                        loader={loader}
                    >
                        <form className="m-credit-application-status__form">
                            <Select
                                label={contentInfo?.referencias?.[0]?.nombre}
                                name="documentType"
                                id="m-credit-payment-step-one__document-type"
                                register={register}
                                options={optionsTypeDoc.map((info: any) => {
                                    return {
                                        name: info.name,
                                        value: info.id,
                                    };
                                })}
                                setValue={setValue}
                                square={true}
                                validationRules={{
                                    required: {
                                        value: true,
                                        message: 'Campo requerido',
                                    },
                                }}
                                required={true}
                                error={errors.documentType}
                                defaultValue={{
                                    name: 'Selecciona un tipo de documento',
                                    value: '',
                                }}
                            />
                            <Input
                                label={contentInfo.referencias[1].nombre}
                                name="document"
                                maxLength="25"
                                type="number"
                                square={true}
                                placeholder={'Escribe el numero de documento'}
                                register={register}
                                validationRules={{
                                    required: {
                                        value: true,
                                        message: 'Campo requerido',
                                    },
                                    pattern: {
                                        value: /^[{0-9}]+$/,
                                        message:
                                            'No se permiten caracteres especiales',
                                    },
                                    maxLength: {
                                        value: 25,
                                        message:
                                            'El documento no debe superar los 25 dígitos',
                                    },
                                    minLength: {
                                        value: 5,
                                        message:
                                            'El documento debe tener al menos 5 dígitos',
                                    },
                                }}
                                setValue={setValue}
                                required={true}
                                error={errors.document}
                            />
                        </form>
                    </FormAndNoteTemplate>
                    {openModalError && <>{openModalError}</>}
                    {openToast && <>{openToast}</>}
                    {visualizationModal && <>{visualizationModal}</>}
                    {showConfirmation && <>{showConfirmation}</>}
                </>
            )}
        </>
    );
};

export default CollaboratorAffiliationCertificate;
